import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2463EB',
      light: '#00AE72',
      dark: '#212125',
      contrastText: '#fff',
    },
    secondary: {
      main: '#dc004e',
      light: '#F7F39A',
      dark: '#9a0036',
      contrastText: '#707070',
    },
  },
  typography: {
    fontFamily: '"DMSans", "NotoSans", sans-serif',
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
        },
      },
    },
  },
});

export default theme;
